// theme.js

import { createTheme } from "@mui/material/styles";
import { get } from "firebase/database";

export function getCssVar(name) {
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

export function buildTheme() {
    return createTheme({
        palette: {
            background: {
                default: getCssVar("--mui-background-default"),
                paper: getCssVar("--mui-background-paper"),
            },
            text: {
                primary: getCssVar("--mui-text-primary"),
                secondary: getCssVar("--mui-text-secondary"),
            },
            primary: {
                main: getCssVar("--mui-primary-main"),
                light: getCssVar("--mui-primary-light"),
                dark: getCssVar("--mui-primary-dark"),
                contrastText: getCssVar("--mui-primary-contrastText"),
            },
            secondary: {
                main: getCssVar("--mui-secondary-main"),
                light: getCssVar("--mui-secondary-light"),
                dark: getCssVar("--mui-secondary-dark"),
                contrastText: getCssVar("--mui-secondary-contrastText"),
            },
        },
        components: {
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: getCssVar("--mui-text-primary"),   // default border
                        },
                    },
                },
            },

            MuiDataGrid: {
                styleOverrides: {
                    root: {
                        backgroundColor: getCssVar("--mui-background-paper"),
                    },
                    columnHeaders: {
                        backgroundColor: getCssVar("--mui-background-paper"),
                        color: getCssVar("--mui-text-primary"),
                        fontWeight: 600,
                    },
                    columnHeader: {
                        color: getCssVar("--mui-text-primary"),
                        fontSize: '0.9rem',
                    },
                },
            },

            MuiToggleButton: {
                styleOverrides: {
                    root: {
                        backgroundColor: getCssVar("--mui-background-paper"),
                        color: getCssVar("--mui-text-primary"),
                        "&.Mui-selected": {
                            backgroundColor: getCssVar("--mui-primary-main"),
                            color: getCssVar("--mui-primary-contrastText"),
                            transition: "background-color 0.3s",
                        },
                        "&.Mui-selected:hover": {
                            backgroundColor: getCssVar("--mui-primary-dark"),
                        },
                    },
                },
            },

            // MuiTableRow: {
            //     styleOverrides: {
            //         root: {
            //             "&:hover": {
            //                 backgroundColor: "transparent"
            //             }
            //         }
            //     }
            // }
        }
    });
}

